import axios from '../../axios';
import { AxiosRequestConfigExtended } from '../../axios';

export default class AuthService {
  private static decodeJwt(token: string) {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (e) {
      console.error('Error decoding JWT:', e);
      return null;
    }
  }

  static logIn(formData: { email: string; password: string }) {
    const config: AxiosRequestConfigExtended = {
      _bypassInterceptor: true,
    };
    return axios
      .post('/user/login', { ...formData }, config)
      .then((response) => {
        if (response.status === 201) {
          console.log('=== Login Response ===');
          console.log('Full response data:', response.data);
          console.log('Available fields:', Object.keys(response.data));
          console.log('===================');

          localStorage.setItem('user', JSON.stringify(response.data));
          return response.data;
        }
        return response.data;
      })
      .catch((error) => {
        console.error('Login failed:', error);
        throw error;
      });
  }

  static logOut() {
    localStorage.removeItem('user');
  }

  static getCurrentUser() {
    const user = localStorage.getItem('user');
    if (user) {
      return JSON.parse(user);
    }
    return null;
  }

  static async refreshToken() {
    try {
      const user = this.getCurrentUser();
      if (!user?.refresh_token) {
        throw new Error('No refresh token available');
      }

      const response = await axios.post(
        '/refreshToken',
        {
          refresh_token: user.refresh_token,
        },
        {
          _bypassInterceptor: true,
        } as AxiosRequestConfigExtended
      );

      // Update stored user data with new tokens
      const updatedUser = { ...user, ...response.data };
      localStorage.setItem('user', JSON.stringify(updatedUser));

      return response.data.access_token;
    } catch (error) {
      console.error('Token refresh failed:', error);
      throw error;
    }
  }
}
